import AppointmentList from "./AppointmentList/AppointmentList.vue";
import AppointmentsService from "@/services/AppointmentsService";
import { toQuery, fromQuery } from "@/utils/filterQuery";

// Função (não constante) pra só ler os services depois dos módulos carregarem
const buildFields = () => {
  const STATUS = AppointmentsService.STATUS;
  return [
  {
    key: "status",
    label: "Status",
    type: "multi",
    options: [
      { value: STATUS.AGUARDANDO, label: "Aguardando" },
      { value: STATUS.AGENDADO, label: "Agendada" },
      { value: STATUS.ANDAMENTO, label: "Em andamento" },
      { value: STATUS.CONCLUIDO, label: "Concluída" },
      { value: STATUS.CANCELADO, label: "Cancelada" },
      { value: STATUS.RECUSADO, label: "Recusada" },
    ],
  },
  {
    key: "online",
    label: "Online",
    type: "select",
    options: [
      { value: "true", label: "Online" },
      { value: "false", label: "Presencial" },
    ],
  },
  {
    key: "filter",
    label: "Pagamento",
    type: "select",
    options: [{ value: "payment_ok", label: "Pagamento confirmado" }],
  },
  { key: "date_start", label: "Sessão de", type: "date" },
  { key: "date_end", label: "Sessão até", type: "date" },
  { key: "price_from", label: "Valor de (R$)", type: "number" },
  { key: "price_to", label: "Valor até (R$)", type: "number" },
  ];
};

export default {
  name: "Appointments",
  data() {
    const fields = buildFields();
    let filters = fromQuery(fields, this.$route.query);
    // Sem filtro na URL: começa no mês atual (comportamento anterior da tela)
    if (!Object.keys(filters).length) {
      filters = {
        date_start: this.$moment().startOf("month").format("YYYY-MM-DD"),
        date_end: this.$moment().endOf("month").format("YYYY-MM-DD"),
      };
    }
    return {
      fields,
      filters,
      total: null,
      recurrencyIdFilter: this.$route.query.recurrency_id || null,
    };
  },
  computed: {
    listFilters() {
      return {
        ...this.filters,
        ...(this.recurrencyIdFilter && {
          recurrency_id: this.recurrencyIdFilter,
        }),
      };
    },
  },
  watch: {
    "$route.query.recurrency_id"(newVal) {
      this.recurrencyIdFilter = newVal || null;
    },
  },
  methods: {
    syncQuery() {
      const query = toQuery(this.fields, this.filters);
      if (this.recurrencyIdFilter) query.recurrency_id = this.recurrencyIdFilter;
      this.$router.replace({ path: this.$route.path, query }).catch(() => {});
    },
    applyFilters(filters) {
      this.filters = filters;
      this.syncQuery();
    },
    clearRecurrencyFilter() {
      this.recurrencyIdFilter = null;
      this.syncQuery();
    },
  },
  components: {
    AppointmentList,
  },
};
